(() => {
  const rootSelector = '[data-our-stores-locator]';

  function normalize(str) {
    return (str || '').toString().toLowerCase().trim();
  }

  function initLocator(root) {
    const tabs = Array.from(root.querySelectorAll('[data-os-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-os-panel]'));
    const search = root.querySelector('[data-os-search]');
    const cards = Array.from(root.querySelectorAll('[data-os-card]'));

    function setActiveTab(target) {
      const value = target?.getAttribute('data-os-tab');
      tabs.forEach((btn) => btn.setAttribute('aria-selected', btn === target ? 'true' : 'false'));
      panels.forEach((panel) => {
        const isActive = panel.getAttribute('data-os-panel') === value;
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    function applyFilter() {
      if (!search) return;
      const q = normalize(search.value);
      cards.forEach((card) => {
        const hay = normalize(card.getAttribute('data-os-haystack'));
        const visible = q === '' || hay.includes(q);
        card.style.display = visible ? '' : 'none';
      });
    }

    tabs.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setActiveTab(btn);
      });
    });

    if (search) {
      search.addEventListener('input', applyFilter);
      applyFilter();
    }

    const defaultTab = tabs.find((t) => t.getAttribute('aria-selected') === 'true') || tabs[0];
    if (defaultTab) setActiveTab(defaultTab);
  }

  function boot() {
    document.querySelectorAll(rootSelector).forEach((root) => initLocator(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

